/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 3/4/21
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { Col, Row } from 'reactstrap';
import Footer from 'components/support/layout/Footer';
import Header from 'components/support/layout/Header';
import Main from 'components/support/layout/MainContainer';
import MainHeadingRow from 'components/support/layout/MainHeadingRow';
import Page from 'components/support/layout/Page';
import ResetPasswordForm from './ResetPasswordForm';

const Index = () => (
  <Page className="reset-password-page">
    <Header inApp={false} />
    <Main>
      <MainHeadingRow>
        <h1>Reset Password</h1>
      </MainHeadingRow>
      <Row>
        <Col sm="8" className="col">
          <ResetPasswordForm />
        </Col>
      </Row>
    </Main>
    <Footer />
  </Page>
);

export default Index;



// WEBPACK FOOTER //
// ./js/components/pages/ResetPassword/index.jsx